// awsLocation.js
import {
  SearchPlaceIndexForSuggestionsCommand,
  SearchPlaceIndexForTextCommand
} from "@aws-sdk/client-location";
import { locationClient } from "./awsConfig";
import { GetPlaceCommand } from "@aws-sdk/client-location";
import { getConfig } from "../configLoader";
let { apiUrl, identityPoolId, placeIndexName } = getConfig();
const INDEX_NAME =  placeIndexName; //"New-place-index"; // Your Place Index name (HERE provider)
const socalCenter = { lat: 34, lng: -117 };

const defaultBounds = {
  north: socalCenter.lat + 3.22, // 37.22
  south: socalCenter.lat - 3.22, // 30.78
  east: socalCenter.lng + 3.22,  // -113.78
  west: socalCenter.lng - 3.22,  // -120.22
};

// AWS expects [west, south, east, north]
const filterBBox = [
  defaultBounds.west,
  defaultBounds.south,
  defaultBounds.east,
  defaultBounds.north,
];


export async function getAddressSuggestions(query, signal) {


  const command = new SearchPlaceIndexForSuggestionsCommand({
    IndexName: INDEX_NAME,
    Text: query,
    MaxResults: 15,
    FilterCountries: ["USA"],
    FilterCategories: ["StreetType", "AddressType", "IntersectionType", "PointOfInterestType"],
    FilterBBox: filterBBox
  });

  try {
    const response = await locationClient.send(command, { abortSignal: signal });
    console.log("1 :: ", response);

    return { results: response.Results || [], error: false };
  } catch (err){
    if (err.name === "AbortError") {
      console.log("Request aborted:", query);
      return { results: [], error: false };
    } else {
      console.error("Error fetching suggestions:", err);
      return { results: [], error: true };
    }
  }
}

export async function getFullAddress(selectedText) {
  const command = new SearchPlaceIndexForTextCommand({
    IndexName: INDEX_NAME,
    Text: selectedText,
    MaxResults: 1,
  });

  try {
    const response = await locationClient.send(command);
    return response.Results[0]?.Place || null;
  } catch (err) {
    console.error("Error fetching full address:", err);
    return null;
  }
}

export async function getStreetOnly(placeId) {
  try {
    const command = new GetPlaceCommand({
      IndexName: INDEX_NAME,  // same place index used for suggestions
      PlaceId: placeId,
    });
    const response = await locationClient.send(command);

    const place = response.Place;
    const street = [
      place.Address?.StreetNumber,
      place.Address?.Street
    ].filter(Boolean).join(" ");

    return street || place.Label; // fallback if street not available
  } catch (err) {
    console.error("GetPlace error:", err);
    return "";
  }
}

export async function getPlaceInfo(placeId) {
  try {
    const command = new GetPlaceCommand({
      IndexName: INDEX_NAME,  // same place index used for suggestions
      PlaceId: placeId,
    });
    const response = await locationClient.send(command);

    const place = response.Place;

    return place; // fallback if street not available
  } catch (err) {
    console.error("GetPlaceInfo error:", err);
    return "";
  }
}
